<template>
  <div class="todo">
    <h1>{{ msg }}</h1>
    <h3>前端相关</h3>
    Vue.js官网：<a href="https://cn.vuejs.org/v2/guide/" target="_blank" >https://cn.vuejs.org/v2/guide/</a><br/>
    Elment-Ui官网：<a href="http://element-cn.eleme.io/#/zh-CN/" target="_blank" >http://element-cn.eleme.io/#/zh-CN/</a><br/>
    Mint-Ui官网：<a href="http://mint-ui.github.io/#!/zh-cn" target="_blank" >http://mint-ui.github.io/#!/zh-cn</a><br/>   
    JS菜鸟教程：<a href="http://www.runoob.com/js/js-intro.html" target="_blank" >http://www.runoob.com/js/js-intro.html</a><br/>
    图表：<a href="http://blog.gdfengshuo.com/example/#/vue-schart" target="_blank" >http://blog.gdfengshuo.com/example/#/vue-schart</a><br/>
  </div>
</template>

<script>
export default {
  name: 'todo',
  data () {
    return {
      msg: '新框架参考资料'
    }
  }
}
</script>




// WEBPACK FOOTER //
// Todo.vue?41f57126